var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconQuestion02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  fillRule: "evenodd",
  d: "M7 1.633a5.367 5.367 0 1 0 0 10.734A5.367 5.367 0 0 0 7 1.633M.7 7a6.3 6.3 0 1 1 12.6 0A6.3 6.3 0 0 1 .7 7",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  fillRule: "evenodd",
  d: "M7.294 3.987a1.44 1.44 0 0 0-1.604.943l-.155.44-.88-.31.154-.44a2.376 2.376 0 0 1 4.617.792c0 1.062-.62 1.673-1.194 1.993-.26.146-.516.237-.715.292V9.06h-.933V6.906l.41-.048.01-.002.045-.007q.064-.011.18-.04a2.4 2.4 0 0 0 .548-.218c.38-.213.716-.557.716-1.18a1.44 1.44 0 0 0-1.199-1.424M6.521 10.5c0-.322.262-.584.584-.584h.006a.583.583 0 0 1 0 1.167h-.006a.583.583 0 0 1-.584-.583",
  clipRule: "evenodd"
})));
export default SvgIconQuestion02;